import React from 'react';
// styles
import styled from 'styled-components';

const TrackingIcon = ({ className, ...props }) => (
  <svg
    {...props}
    aria-label="Tracking"
    className={className}
    role="img"
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.33333 9.73044C2.33333 6.68056 1.33333 4.61534 1.33333 3.53478C1.33333 1.91395 2.67648 0.600002 4.33333 0.600002C5.99019 0.600002 7.33333 1.91395 7.33333 3.53478C7.33333 4.61534 6.33333 6.68056 4.33333 9.73044ZM1.01538 5.1C1.53675 6.52677 2.64273 8.52918 4.33333 11.1072C6.02394 8.52918 7.12992 6.52677 7.65129 5.1H8C8.55229 5.1 9 5.54772 9 6.1V12.163C8.13739 12.385 7.5 13.1681 7.5 14.1H5C5 12.9954 4.10457 12.1 3 12.1C1.89543 12.1 1 12.9954 1 14.1C0.447715 14.1 0 13.6523 0 13.1V6.1C0 5.54772 0.447715 5.1 1 5.1H1.01538ZM11.5 14.1C11.5 13.1681 10.8626 12.385 10 12.163V7.6C10 7.04772 10.4477 6.6 11 6.6H13C14.6569 6.6 16 7.94315 16 9.6L16 13.1C16 13.6523 15.5523 14.1 15 14.1H11.5V14.1ZM14.4951 10.1L11.5 10.0917V8.59077C11.5285 8.26359 11.6951 8.1 12 8.1H13C14 8.18354 14.5 8.65775 14.5 9.52264L14.4951 10.1ZM3 15.6C2.17157 15.6 1.5 14.9284 1.5 14.1C1.5 13.2716 2.17157 12.6 3 12.6C3.82843 12.6 4.5 13.2716 4.5 14.1C4.5 14.9284 3.82843 15.6 3 15.6ZM8 14.1C8 14.9284 8.67157 15.6 9.5 15.6C10.3284 15.6 11 14.9284 11 14.1C11 13.2716 10.3284 12.6 9.5 12.6C8.67157 12.6 8 13.2716 8 14.1ZM5.33333 3.53478C5.33333 4.07506 4.88562 4.51305 4.33333 4.51305C3.78105 4.51305 3.33333 4.07506 3.33333 3.53478C3.33333 2.99451 3.78105 2.55652 4.33333 2.55652C4.88562 2.55652 5.33333 2.99451 5.33333 3.53478Z"
      fill="#263340"
    />
  </svg>
);

export default styled(TrackingIcon)``;
